import FullCalendar from '@fullcalendar/react'

import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import moment from 'moment'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useAppConfig} from '../../context/app/AppContext'
import {getLanguageCode} from '../../i18n/LanguageUtils'
import TranslateUtils from '../../i18n/TranslateUtils'
import {useAuth} from '../authentication/AuthProvider'
import {permissionOptionKeys} from '../role/RoleConstant'
import {useRoleContext} from '../role/RoleProvider'
import {usePatientContext} from '../styled-component/information/StyleDetailInformationWrapper'
import CalendarForm from './CalendarForm'
import {useListReminders} from './query-keys/ReminderKeysManager'
import {reminderTypes} from './ReminderConstants'
import ReminderTable from './ReminderTable'
import './style/fullcalendar.css'

// const events = [{title: 'Meeting', start: new Date()}]

const fontSize = 'text-xs sm:text-xs md:text-xl lg:text-xl'
export function Pharmacy() {
    //#region Translate
    const {translateCommons} = TranslateUtils()
    //#endregion

    //#region Context
    const {user} = useAuth()
    const {myRolePermissions} = useRoleContext()
    const {handleCheckPermissionByKey} = usePatientContext()
    const {userRole, timezoneId} = useAppConfig()
    //#endregion

    //#region Ref
    const reminderTableRef = useRef(null)
    const calendarRef = useRef(null)
    //#endregion

    //#region ID
    const {id: idString} = useParams()
    const id = useMemo(() => {
        return !!idString ? parseInt(idString) : null
    }, [idString])
    //#endregion

    //#region State
    const [currentDateView, setCurrentDateView] = useState(
        moment(new Date()).format('yyyy-MM'),
    )
    //#endregion

    //#region Query
    const {data, refetch} = useListReminders(user?.id, timezoneId, {
        userId: id,
        dateFrom: currentDateView,
        dateTo: currentDateView,
    })
    //#endregion

    //#region Effect
    useEffect(() => {
        calendarRef?.current?.getApi()?.updateSize()
    }, [])

    // useEffect(() => {
    //     if (!!id) {
    //         tableEvent.on('RELOAD-DATA-TABLE-' + QueryKey + id, refetch)

    //         return () => {
    //             removeReloadDataTable(QueryKey + id)
    //         }
    //     }
    // }, [id, refetch])
    //#endregion

    //#region Handle Function
    const handleOnClickEvent = id => {
        if (!!id && data && Array.isArray(data)) {
            let item = {}
            for (let i = 0; i < data.length; i++) {
                if (data[i]?.id === id) {
                    item = {
                        ...data[i],
                        startDate: data[i]?.start
                            ? moment(data[i].start).toDate()
                            : null,
                        endDate: data[i]?.end
                            ? moment(data[i].end).toDate()
                            : null,
                    }
                    break
                }
            }

            // reminderFormRef?.current?.showForm(item)
            calendarForm?.current?.showForm(item)
        }
    }

    const handleOnClickDay = day => {
        if (!!day && data && Array.isArray(data)) {
            let placeholder = []
            for (let i = 0; i < data.length; i++) {
                if (
                    data[i]?.start?.includes(day) ||
                    data[i]?.end?.includes(day)
                ) {
                    placeholder.push({
                        ...data[i],
                        startDate: data[i]?.start
                            ? moment(data[i].start)
                                  .toDate()
                                  .toLocaleDateString() +
                              ' ' +
                              moment(data[i].start)
                                  .toDate()
                                  .toLocaleTimeString()
                            : null,
                        endDate: data[i]?.end
                            ? moment(data[i].end)
                                  .toDate()
                                  .toLocaleDateString() +
                              ' ' +
                              moment(data[i].end).toDate().toLocaleTimeString()
                            : null,
                    })
                }
            }

            reminderTableRef?.current?.showForm(day, placeholder)
        }
    }

    const getEventCustomStyle = data => {
        let className = ''
        if (data.type === reminderTypes.reminder) {
            className = 'reminder-wrapper text-gray-800  '
        }
        if (data.type === reminderTypes.appointment) {
            className = 'appointment-wrapper text-gray-800 '
        }
        return className
    }
    //#endregion
    const customEventContent = info => {
        const {extendedProps} = info.event

        return (
            <div
                className={` flex w-full overflow-x-hidden border-round-md ${getEventCustomStyle(
                    extendedProps,
                )}`}>
                <div className="">
                    <div
                        className={` border-round-left-md  h-full ${
                            extendedProps.type === reminderTypes.appointment
                                ? 'appointment-item'
                                : ' reminder-item'
                        }`}
                        style={{padding: '2.5px'}}></div>
                </div>
                <div className={`w-full p-2 border-round-md `}>
                    <div className="flex align-items-center gap-2">
                        <div>
                            <i
                                className={
                                    extendedProps.type ===
                                    reminderTypes.reminder
                                        ? `pi pi-bell`
                                        : `pi pi-calendar`
                                }
                            />
                        </div>
                        <div>
                            <p
                                style={{
                                    wordBreak: 'keep-all', // Force break long words
                                    overflowWrap: 'break-word', // Break text when it overflows
                                    whiteSpace: 'normal', // Allow normal line breaks
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                }}>
                                {extendedProps.type ===
                                reminderTypes.appointment
                                    ? `Appointment with ${extendedProps.ownerName} `
                                    : 'Reminder'}
                            </p>
                        </div>
                    </div>
                    {extendedProps.type === reminderTypes.appointment ? (
                        <small
                            className="m-0 p-0 font-semibold"
                            style={{
                                wordBreak: 'break-all', // Force break long words
                                overflowWrap: 'break-word', // Break text when it overflows
                                whiteSpace: 'normal', // Allow normal line breaks
                            }}>{`${extendedProps.appointmentType} `}</small>
                    ) : (
                        ''
                    )}
                    <div> </div>
                    <div className="flex gap-2">
                        <small
                            className="m-0 p-0 font-semibold"
                            style={{
                                wordBreak: 'break-word', // Handle small text overflow
                                overflowWrap: 'anywhere',
                            }}>
                            At: {info.timeText}
                        </small>
                    </div>
                </div>
            </div>
        )
    }

    const calendarForm = useRef(null)

    return (
        <React.Fragment>
            <div className="col-12 p-0 " style={{minHeight: '75vh'}}>
                {/* {width <= 750 && (
                    <div className="flex justify-content-between align-items-center mb-3">
                        <div
                            className="p-inputgroup gap-1 grid"
                            style={{width: 'unset'}}>
                            <Button
                                icon="fc-icon fc-icon-chevron-left"
                                className={`${fontSize}`}
                                onClick={() =>
                                    calendarRef.current?.getApi()?.prev()
                                }
                            />
                            <Button
                                icon="fc-icon fc-icon-chevron-right"
                                className={`${fontSize}`}
                                onClick={() =>
                                    calendarRef.current?.getApi()?.next()
                                }
                            />
                            <Button
                                label={translateCommons('Today')}
                                className={`${fontSize}`}
                                onClick={() =>
                                    calendarRef.current?.getApi()?.today()
                                }
                            />
                        </div>

                        <div
                            className="p-inputgroup grid gap-1"
                            style={{width: 'unset'}}>
                            <Button
                                label={translateCommons('Month')}
                                className={`${fontSize}`}
                                onClick={() =>
                                    calendarRef.current
                                        ?.getApi()
                                        ?.changeView('dayGridMonth')
                                }
                            />
                            <Button
                                label={translateCommons('Week')}
                                className={`${fontSize}`}
                                onClick={() =>
                                    calendarRef.current
                                        ?.getApi()
                                        ?.changeView('timeGridWeek')
                                }
                            />
                            <Button
                                label={translateCommons('Day')}
                                className={`${fontSize}`}
                                onClick={() =>
                                    calendarRef.current
                                        ?.getApi()
                                        ?.changeView('timeGridDay')
                                }
                            />
                        </div>
                    </div>
                )} */}

                <div id={'reservation-calendar'} className="relative">
                    <FullCalendar
                        ref={calendarRef}
                        locale={
                            getLanguageCode() === 'gb'
                                ? 'en'
                                : getLanguageCode()
                        }
                        style={{minWidth: '25rem'}}
                        plugins={[
                            dayGridPlugin,
                            timeGridPlugin,
                            interactionPlugin,
                        ]}
                        navLinkDayClick={date => {
                            let formattedDate =
                                moment(date).format('YYYY-MM-DD')
                            handleOnClickDay(formattedDate)
                        }}
                        events={data}
                        initialView="dayGridMonth"
                        // select={e => handleOnClickEvent(e)}
                        headerToolbar={{
                            left: `${'prevButton,nextButton today'}`,
                            center: 'title',
                            right: `${
                                handleCheckPermissionByKey(
                                    permissionOptionKeys?.allowToAddReminders,
                                )
                                    ? 'addButton dayGridMonth,timeGridWeek'
                                    : 'dayGridMonth,timeGridWeek'
                            }`,
                        }}
                        buttonText={{
                            today: translateCommons('Today'),
                            month: translateCommons('Month'),
                            week: translateCommons('Week'),
                            // day: translateCommons('Day'),
                        }}
                        selectMirror
                        selectable={true}
                        themeSystem="minty"
                        editable={false}
                        eventTimeFormat={{
                            hour: '2-digit',
                            minute: '2-digit',
                            omitZeroMinute: false,
                            meridiem: 'short',
                            hour12: false,
                        }}
                        eventClick={e => {
                            e.jsEvent.preventDefault()
                            handleOnClickEvent(
                                e.event.id ? parseInt(e.event.id) : null,
                            )
                        }}
                        dateClick={e => handleOnClickDay(e.dateStr)}
                        navLinks
                        handleWindowResize
                        windowResize={() =>
                            calendarRef.current?.getApi()?.updateSize()
                        }
                        dayMaxEvents
                        nowIndicator
                        displayEventEnd
                        progressiveEventRendering
                        customButtons={{
                            addButton: {
                                text: (
                                    <div>
                                        <span className="flex gap-1 align-items-center">
                                            <span className="pi pi-plus mr-2"></span>

                                            {translateCommons('Add New')}
                                        </span>
                                    </div>
                                ),
                                click: function () {
                                    calendarForm?.current?.showForm({
                                        type: reminderTypes.reminder,
                                    })
                                },
                            },
                            prevButton: {
                                icon: 'fc-icon fc-icon-chevron-left',
                                click: function () {
                                    calendarRef?.current?.getApi().prev()
                                    setCurrentDateView(
                                        moment(
                                            calendarRef?.current
                                                ?.getApi()
                                                ?.getDate(),
                                        ).format('yyyy-MM'),
                                    )
                                },
                            },
                            nextButton: {
                                icon: 'fc-icon fc-icon-chevron-right',
                                click: function () {
                                    calendarRef?.current?.getApi().next()
                                    setCurrentDateView(
                                        moment(
                                            calendarRef?.current
                                                ?.getApi()
                                                ?.getDate(),
                                        ).format('yyyy-MM'),
                                    )
                                },
                            },
                        }}
                        eventContent={customEventContent}
                    />
                </div>
            </div>
            <ReminderTable ref={reminderTableRef} />
            <CalendarForm ref={calendarForm} />
        </React.Fragment>
    )
}
